import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import Cookies from 'js-cookie';
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
	token:null,
	count:2,
	userInfo:null,
	searchQuery: null,
	userId:'',
	language:'chinese',
  },
  mutations: {
	changeToken(state,newValue){
		state.token = newValue
		Cookies.set('token', JSON.stringify(newValue));
	},
	changeCount(state,newValue){
		state.count = newValue
		Cookies.set('count', JSON.stringify(newValue));
	},
	changeUserInfo(state,newValue){
		state.userInfo = newValue
		Cookies.set('userInfo', JSON.stringify(newValue));
	},
	changeSearchQuery(state,newValue){
		state.searchQuery = newValue
		Cookies.set('searchQuery', JSON.stringify(newValue));
	},
	changeUserId(state,newValue){
		state.userId = newValue
		Cookies.set('userId', JSON.stringify(newValue));
	},
	changeLiveId(state,newValue){
		state.liveId = newValue
		Cookies.set('liveId', JSON.stringify(newValue));
	},
	changeLanguage(state,newValue){
		state.language = newValue
		Cookies.set('language', JSON.stringify(newValue));
	},
  },
});
const data = {}

const token = Cookies.get('token')
if (token) {
  data.token = JSON.parse(token)
}
const count = Cookies.get('count')
if (count) {
  data.count = JSON.parse(count)
}
const userInfo = Cookies.get('userInfo')
if (userInfo) {
  data.userInfo = JSON.parse(userInfo)
}
const searchQuery = Cookies.get('searchQuery')
if (searchQuery) {
  data.searchQuery = JSON.parse(searchQuery)
}
const userId = Cookies.get('userId')
if (userId) {
  data.userId = JSON.parse(userId)
}
const liveId = Cookies.get('liveId')
if (liveId) {
  data.liveId = JSON.parse(liveId)
}
const language = Cookies.get('language')
if (language) {
  data.language = JSON.parse(language)
}
store.replaceState(data);

export default store;


// WEBPACK FOOTER //
// ./src/vuex/store.js